import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const headerStyles: CSSProperties = {
  width: '100%',
  height: '40%',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  overflow: 'hidden'
};

export const backgroundAnimationStyles: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  opacity: 0.4,
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 0
};

export const contentStyles: CSSProperties = {
  zIndex: 1,
  textAlign: 'center'
};

export const tonTextStyles: CSSProperties = {
  padding: '0px 0',
  margin: 0,
  fontSize: '18px'
};

export const valueTextStyles: CSSProperties = {
  padding: '0px 0',
  margin: 0,
  fontWeight: 'bold',
  fontSize: '28px'
};

export const usdTextStyles: CSSProperties = {
  padding: '1px 0',
  margin: 0,
  color: 'rgb(110 110 110)',
  fontSize: '13px'
};

export const buttonContainerStyles: CSSProperties = {
  background: '#000',
  borderRadius: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1
};

export const buttonTextStyles: CSSProperties = {
  fontSize: '13px',
  padding: '10px 18px',
  fontWeight: 'bold',
  color: '#FFF',
  fontFamily: UIConfig.Fonts.Primary,
  textAlign: 'center'
};

export const connectButtonWrapperStyles: CSSProperties = {
  position: 'absolute',
  top: '100%',
  width: '150px',
  left: '50%',
  transform: 'translateX(-50%)',
  marginTop: '20px',
  background: '#000',
  borderRadius: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1
};

export const connectedWalletContainerStyles: CSSProperties = {
  position: 'absolute',
  bottom: '20px',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1
};

export const connectedWalletWrapperStyles: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 'calc(100% - 40px)'
};

export const walletAddressContainerStyles: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  marginBottom: '10px'
};

export const addressTextStyles: CSSProperties = {
  fontSize: '13px',
  fontFamily: UIConfig.Fonts.Primary
};

export const dividerStyles: CSSProperties = {
  width: '100%',
  height: '1px',
  backgroundColor: 'rgba(128, 128, 128, 0.3)',
  marginBottom: '10px'
};
